import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./LookAlikeProducts.scss";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LookAlikeProducts from "app/pages/.shared/LookAlikeProduct/LookAlikeProducts";
import { fetchLookAlikeProducts } from "app/pages/.shared/LookAlikeProduct/lookAlikeProductsActionCreators";
import { resolutionPropType } from "app/utils/propTypes";
import isArray from "lodash/isArray";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const LookAlikeProductsContainer = ({ productId, fetchLookAlikeProducts, resolution }) => {
	const [products, setProducts] = useState([]);

	const { track } = useAnalytics();

	useEffect(() => {
		if (productId) {
			fetchLookAlikeProducts(productId).then(res => {
				// we check if it is an array because sometimes the endpoint return html content when the endpoint is not correctly set up
				if (res.status === 200 && isArray(res.data) && res.data.length > 0) {
					setProducts(res.data);
				} else {
					track("fetch-look-alike-products-error", {
						productId,
					});
				}
			});
		}
	}, [productId]);

	return <LookAlikeProducts products={products} resolution={resolution} />;
};

LookAlikeProductsContainer.propTypes = {
	productId: PropTypes.string,
	fetchLookAlikeProducts: PropTypes.func,
	resolution: resolutionPropType,
};

const mapStateToProps = state => {
	return {
		resolution: state.resolution,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchLookAlikeProducts,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(LookAlikeProductsContainer);
